export default class StringUtil {
  /**
   * 半角英数判定
   * @param str
   */
  static isHanEisu(str = "") {
    return /^[A-Za-z0-9]*$/.test(str)
  }

  /**
   * ゼロで埋める
   * @param {number} num
   * @param {number} len
   */
  static zeroPadding(num: number, len = 2) {
    return (Array(len).join("0") + num).slice(-len)
  }

  /**
   * pos桁ごとにカンマを挿入する
   * @param {number} num 対象の数字
   * @param {number} pos 挿入する位置
   */
  static addComma(num: number | string, pos = 3): string {
    const reg = new RegExp(`^(-?\\d+)(\\d{${pos}})`)
    const _num = String(num).replace(reg, "$1,$2")
    if (_num !== num) {
      return this.addComma(_num, pos)
    }

    return _num
  }

  /**
   * 改行を削除
   * @param str
   */
  static removeLineBreak(str: string) {
    return str.replace(/(\r\n|\n|\r)/gm, "")
  }
}
